import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingSignUpSplit } from "@faire/retailer-visitor-shared/settings/useSettingSignUpSplit";
import { useQuery as useRetailerQuery } from "@faire/web-api--source/endpoints/www/api/retailer/retailerToken/get-hooks";

export const useSignUpOwFApplication = () => {
  const { retailer: initialData } = useRetailer();
  const isSignUpSplitEnabled = useSettingSignUpSplit();
  const { data: retailer } = useRetailerQuery("me", undefined, {
    refetchOnMount: false,
    enabled: isSignUpSplitEnabled,
  });

  return retailer?.launch_with_faire ?? initialData?.launch_with_faire;
};
